export default "__VITE_ASSET__FbrgdyjQ__"